import type { ThemeDefinition } from "@omega/theme";

import { FOREST_THEME } from "./presets/forest.theme";
import { MOBILE_DARK_THEME } from "./presets/mobile-dark.theme";
import { MOBILE_THEME } from "./presets/mobile.theme";
import { NORD_THEME } from "./presets/nord.theme";
import { SUNSET_THEME } from "./presets/sunset.theme";

/** Ключ storage выбранной темы (совпадает с anti-FOUC скриптом в `index.html`). */
export const THEME_STORAGE_KEY = "ompmobile:theme";

/** Реестр тем приложения. */
export const THEMES: ThemeDefinition[] = [MOBILE_THEME, MOBILE_DARK_THEME, FOREST_THEME, SUNSET_THEME, NORD_THEME];

const themeById = new Map(THEMES.map((theme) => [theme.id, theme]));

/**
 * Тема по id или `undefined`.
 * @param id id темы
 */
export function getThemeById(id: string): ThemeDefinition | undefined {
    return themeById.get(id);
}

/**
 * Валидный id из storage или id первой темы реестра.
 * @param id значение из storage / `null`
 */
export function getThemeIdOrFirst(id: string | null): string {
    if (id != null && themeById.has(id)) return id;
    return THEMES[0]?.id ?? "mobile";
}
